<script>
  import { ButtonGroup } from 'element-ui'
  export default {
    name:'ElButtonGroup',
    extends:ButtonGroup
  }
</script>
